import { useState } from "react";
import styles from "../reporting.module.scss";

const PREVIEW_LIMIT = 100;

const getPreview = (text: string) => {
  const slice = text.slice(0, PREVIEW_LIMIT);
  const lastSpace = slice.lastIndexOf(" ");
  const trimmed = lastSpace > 40 ? slice.slice(0, lastSpace) : slice;
  return `${trimmed.trimEnd()}...`;
};

const ReviewText = ({ text }: { text: string }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = text.length > PREVIEW_LIMIT;

  if (!isLong) {
    return <span className={styles.reviewText}>{text}</span>;
  }

  return (
    <span className={styles.reviewText}>
      {expanded ? text : getPreview(text)}{" "}
      <button
        type="button"
        className={styles.reviewViewMore}
        aria-expanded={expanded}
        onClick={() => setExpanded((open) => !open)}
      >
        {expanded ? "View Less" : "View More"}
      </button>
    </span>
  );
};

export default ReviewText;
